<template>
  <div ref="blockRef" class="grid gap-6 mx-auto px-4 max-w-6xl md:grid-cols-2">
    <div
      class="flex flex-col p-6 bg-white rounded-4xl border border-purple-dark lg:p-12"
      data-gsap-target="column"
    >
      <div
        v-if="block.text"
        v-html="block.text"
        class="prose"
      />

      <Buttons
        v-if="block.buttons?.length"
        :buttons="block.buttons"
        class="mt-auto pt-8"
      />
    </div>

    <div
      v-if="block.employees?.length"
      class="flex flex-col items-center p-6 bg-purple-dark rounded-4xl lg:p-12"
      data-gsap-target="column"
    >
      <h3 v-if="block.title_above_employees" class="font-serif font-bold text-white text-2xl text-center">
        {{ block.title_above_employees }}
      </h3>

      <div class="flex gap-4 mt-6">
        <NuxtLink
          v-for="(employee, index) in block.employees"
          :to="employee.url"
          :key="employee.id"
          :class="`
            flex flex-col items-center shrink-0 text-white text-center max-w-32
            ${index === 1 ? 'mt-12' : ''}
            ${index === 2 ? 'hidden sm:flex md:hidden lg:flex' : ''}
          `"
        >
          <img
            v-if="employee.image && employee.image.sm"
            :src="employee.image.sm.url"
            :alt="employee.image.sm.alt"
            class="shrink-0 size-32 object-cover rounded-full border-2 border-white bg-gradient-employee"
            :width="employee.image.sm.width"
            :height="employee.image.sm.height"
            loading="lazy"
            draggable="false"
          >

          <div class="mt-4 font-serif font-medium">
            {{ employee.title }}
          </div>

          <div class="text-xs">
            {{ employee.position }}
          </div>
        </NuxtLink>
      </div>

      <Buttons
        v-if="block.buttons_below_employees?.length"
        :buttons="block.buttons_below_employees"
        class="flex justify-center mt-8"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { TextEmployees } from '~/statamic/types/block';

defineProps<{
  block: TextEmployees;
}>();

let ctx: gsap.Context | null;
const blockRef = ref();

onMounted(() => {
  ctx = useGsap.context((self) => {
    if (typeof self.selector !== 'function') return;

    const columns = self.selector('[data-gsap-target="column"]');

    if (columns?.length) {
      useGsap.from(columns, {
        x: 50,
        y: 50,
        stagger: 0.25,
        autoAlpha: 0,
        scrollTrigger: {
          start: 'top bottom',
          trigger: blockRef.value,
        },
      });
    }
  }, blockRef.value);
});

onUnmounted(() => {
  ctx?.revert();
});
</script>
